// Generated by purs version 0.14.5
"use strict";
var Control_Alt = require("../Control.Alt/index.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Lazy = require("../Control.Lazy/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_List = require("../Data.List/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Number = require("../Data.Number/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_CodeUnits = require("../Data.String.CodeUnits/index.js");
var Data_String_Common = require("../Data.String.Common/index.js");
var Data_String_NonEmpty_CodeUnits = require("../Data.String.NonEmpty.CodeUnits/index.js");
var Data_String_NonEmpty_Internal = require("../Data.String.NonEmpty.Internal/index.js");
var QuantityFormula_Types = require("../QuantityFormula.Types/index.js");
var Text_Parsing_StringParser = require("../Text.Parsing.StringParser/index.js");
var Text_Parsing_StringParser_CodePoints = require("../Text.Parsing.StringParser.CodePoints/index.js");
var Text_Parsing_StringParser_CodeUnits = require("../Text.Parsing.StringParser.CodeUnits/index.js");
var Text_Parsing_StringParser_Combinators = require("../Text.Parsing.StringParser.Combinators/index.js");
var Text_Parsing_StringParser_Expr = require("../Text.Parsing.StringParser.Expr/index.js");
var parseNumber = Control_Bind.bind(Text_Parsing_StringParser.bindParser)(Text_Parsing_StringParser_CodeUnits.regex("-?[0123456789]+([\\.][0123456789]+)?"))(function (s) {
    var mNum = Data_Number.fromString(s);
    if (mNum instanceof Data_Maybe.Just) {
        return Control_Applicative.pure(Text_Parsing_StringParser.applicativeParser)(mNum.value0);
    };
    if (mNum instanceof Data_Maybe.Nothing) {
        return Text_Parsing_StringParser.fail("Failed parsing number");
    };
    throw new Error("Failed pattern match at QuantityFormula.Parser (line 100, column 3 - line 102, column 44): " + [ mNum.constructor.name ]);
});
var lexeme = function (p) {
    return Control_Bind.bind(Text_Parsing_StringParser.bindParser)(p)(function (ret) {
        return Control_Bind.discard(Control_Bind.discardUnit)(Text_Parsing_StringParser.bindParser)(Text_Parsing_StringParser_CodeUnits.skipSpaces)(function () {
            return Control_Applicative.pure(Text_Parsing_StringParser.applicativeParser)(ret);
        });
    });
};
var qnumParser = lexeme(Data_Functor.map(Text_Parsing_StringParser.functorParser)(QuantityFormula_Types.QNum.create)(parseNumber));
var convertToUserFormula = function (v) {
    var userFormulaStr = Data_String_Common.replaceAll(".")(",")(Data_String_Common.replaceAll(",")(";")(v));
    return userFormulaStr;
};
var convertToInternalFormula = function (v) {
    var internalFormulaStr = Data_String_Common.replaceAll(";")(",")(Data_String_Common.replaceAll(",")(".")(v));
    return internalFormulaStr;
};
var caseInsensitive = function (pattern) {
    return function (s) {
        var len = Data_String_CodeUnits.length(pattern);
        var prefix = Data_Functor.map(Data_Maybe.functorMaybe)(Data_String_Common.toLower)(Data_String_CodeUnits.slice(s.pos)(s.pos + len | 0)(s.str));
        var $13 = Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(prefix)(new Data_Maybe.Just(pattern));
        if ($13) {
            return new Data_Either.Right({
                result: pattern,
                suffix: {
                    str: s.str,
                    pos: s.pos + len | 0
                }
            });
        };
        return new Data_Either.Left({
            pos: s.pos,
            error: "Expected '" + (pattern + "'.")
        });
    };
};
var piConst = lexeme(Control_Bind.bind(Text_Parsing_StringParser.bindParser)(Text_Parsing_StringParser["try"](caseInsensitive("pi")))(function () {
    return Control_Applicative.pure(Text_Parsing_StringParser.applicativeParser)(QuantityFormula_Types.QFnPi.value);
}));
var piFn0 = lexeme(Control_Bind.bind(Text_Parsing_StringParser.bindParser)(Text_Parsing_StringParser["try"](caseInsensitive("pi()")))(function () {
    return Control_Applicative.pure(Text_Parsing_StringParser.applicativeParser)(QuantityFormula_Types.QFnPi.value);
}));
var pi = Control_Alt.alt(Text_Parsing_StringParser.altParser)(piFn0)(piConst);
var unaryOpParser = function (identifier) {
    return function (astNode) {
        return Control_Bind.bind(Text_Parsing_StringParser.bindParser)(lexeme(caseInsensitive(identifier)))(function (v) {
            return Control_Applicative.pure(Text_Parsing_StringParser.applicativeParser)(astNode);
        });
    };
};
var binOpParser = function (identifier) {
    return function (astNode) {
        return Control_Bind.bind(Text_Parsing_StringParser.bindParser)(lexeme(caseInsensitive(identifier)))(function (v) {
            return Control_Applicative.pure(Text_Parsing_StringParser.applicativeParser)(astNode);
        });
    };
};
var allowedVarNameSpecialChars = [ "_" ];
var allowedVarNameCharacters = Control_Alt.alt(Text_Parsing_StringParser.altParser)(Text_Parsing_StringParser_CodePoints.oneOf(Data_Foldable.foldableArray)(allowedVarNameSpecialChars))(Text_Parsing_StringParser_CodeUnits.alphaNum);
var $$var = Control_Bind.bind(Text_Parsing_StringParser.bindParser)(lexeme(Text_Parsing_StringParser_Combinators.many1(allowedVarNameCharacters)))(function (varName) {
    var s = Data_String_NonEmpty_Internal.toString(Data_String_NonEmpty_CodeUnits.fromFoldable1(Data_List_Types.foldable1NonEmptyList)(varName));
    return Control_Applicative.pure(Text_Parsing_StringParser.applicativeParser)(new QuantityFormula_Types.QVar(s));
});
var qfp = Control_Lazy.fix(Text_Parsing_StringParser.lazyParser)(function (v) {
    return Control_Alt.alt(Text_Parsing_StringParser.altParser)(Control_Alt.alt(Text_Parsing_StringParser.altParser)(Control_Alt.alt(Text_Parsing_StringParser.altParser)(Control_Alt.alt(Text_Parsing_StringParser.altParser)(qnumParser)(functions))(parens))(pi))($$var);
});
var qfParser = Control_Lazy.fix(Text_Parsing_StringParser.lazyParser)(function (v) {
    return Text_Parsing_StringParser_Expr.buildExprParser([ [ new Text_Parsing_StringParser_Expr.Infix(binOpParser("^")(QuantityFormula_Types.QPow.create), Text_Parsing_StringParser_Expr.AssocRight.value) ], [ new Text_Parsing_StringParser_Expr.Infix(binOpParser("*")(QuantityFormula_Types.QTimes.create), Text_Parsing_StringParser_Expr.AssocLeft.value), new Text_Parsing_StringParser_Expr.Infix(binOpParser("/")(QuantityFormula_Types.QDiv.create), Text_Parsing_StringParser_Expr.AssocLeft.value), new Text_Parsing_StringParser_Expr.Infix(binOpParser("\\")(QuantityFormula_Types.QIntDiv.create), Text_Parsing_StringParser_Expr.AssocLeft.value) ], [ new Text_Parsing_StringParser_Expr.Infix(binOpParser("mod")(QuantityFormula_Types.QMod.create), Text_Parsing_StringParser_Expr.AssocRight.value) ], [ new Text_Parsing_StringParser_Expr.Infix(binOpParser("+")(QuantityFormula_Types.QPlus.create), Text_Parsing_StringParser_Expr.AssocLeft.value), new Text_Parsing_StringParser_Expr.Infix(binOpParser("-")(QuantityFormula_Types.QMinus.create), Text_Parsing_StringParser_Expr.AssocLeft.value) ], [ new Text_Parsing_StringParser_Expr.Infix(binOpParser("=")(QuantityFormula_Types.QEqual.create), Text_Parsing_StringParser_Expr.AssocRight.value), new Text_Parsing_StringParser_Expr.Infix(binOpParser(">=")(QuantityFormula_Types.QGTEQ.create), Text_Parsing_StringParser_Expr.AssocRight.value), new Text_Parsing_StringParser_Expr.Infix(binOpParser("<=")(QuantityFormula_Types.QLTEQ.create), Text_Parsing_StringParser_Expr.AssocRight.value), new Text_Parsing_StringParser_Expr.Infix(binOpParser("<>")(QuantityFormula_Types.QNEQ.create), Text_Parsing_StringParser_Expr.AssocRight.value), new Text_Parsing_StringParser_Expr.Infix(binOpParser("<")(QuantityFormula_Types.QLT.create), Text_Parsing_StringParser_Expr.AssocRight.value), new Text_Parsing_StringParser_Expr.Infix(binOpParser(">")(QuantityFormula_Types.QGT.create), Text_Parsing_StringParser_Expr.AssocRight.value) ], [ new Text_Parsing_StringParser_Expr.Prefix(unaryOpParser("not")(QuantityFormula_Types.QNot.create)) ], [ new Text_Parsing_StringParser_Expr.Infix(binOpParser("and")(QuantityFormula_Types.QAnd.create), Text_Parsing_StringParser_Expr.AssocRight.value) ], [ new Text_Parsing_StringParser_Expr.Infix(binOpParser("or")(QuantityFormula_Types.QOr.create), Text_Parsing_StringParser_Expr.AssocRight.value) ], [ new Text_Parsing_StringParser_Expr.Infix(binOpParser("xor")(QuantityFormula_Types.QXor.create), Text_Parsing_StringParser_Expr.AssocRight.value) ] ])(qfp);
});
var parens = Control_Bind.bind(Text_Parsing_StringParser.bindParser)(lexeme(Text_Parsing_StringParser_CodeUnits["char"]("(")))(function () {
    return Control_Bind.bind(Text_Parsing_StringParser.bindParser)(qfParser)(function (e) {
        return Control_Bind.bind(Text_Parsing_StringParser.bindParser)(lexeme(Text_Parsing_StringParser_CodeUnits["char"](")")))(function () {
            return Control_Applicative.pure(Text_Parsing_StringParser.applicativeParser)(new QuantityFormula_Types.QParens(e));
        });
    });
});
var functions = Control_Lazy.fix(Text_Parsing_StringParser.lazyParser)(function (v) {
    return Control_Alt.alt(Text_Parsing_StringParser.altParser)(Control_Alt.alt(Text_Parsing_StringParser.altParser)(Control_Alt.alt(Text_Parsing_StringParser.altParser)(Control_Alt.alt(Text_Parsing_StringParser.altParser)(Control_Alt.alt(Text_Parsing_StringParser.altParser)(Control_Alt.alt(Text_Parsing_StringParser.altParser)(Control_Alt.alt(Text_Parsing_StringParser.altParser)(Control_Alt.alt(Text_Parsing_StringParser.altParser)(Control_Alt.alt(Text_Parsing_StringParser.altParser)(Control_Alt.alt(Text_Parsing_StringParser.altParser)(Control_Alt.alt(Text_Parsing_StringParser.altParser)(Control_Alt.alt(Text_Parsing_StringParser.altParser)(fn1Parser("int")(QuantityFormula_Types.QFnInt.create))(fn1Parser("fix")(QuantityFormula_Types.QFnFix.create)))(fn1Parser("abs")(QuantityFormula_Types.QFnAbs.create)))(fn1Parser("sgn")(QuantityFormula_Types.QFnSgn.create)))(fn1Parser("sqr")(QuantityFormula_Types.QFnSqr.create)))(fn1Parser("log")(QuantityFormula_Types.QFnLog.create)))(fn1Parser("exp")(QuantityFormula_Types.QFnExp.create)))(fn1Parser("sin")(QuantityFormula_Types.QFnSin.create)))(fn1Parser("cos")(QuantityFormula_Types.QFnCos.create)))(fn1Parser("tan")(QuantityFormula_Types.QFnTan.create)))(fn2Parser("min")(QuantityFormula_Types.QFnMin.create)))(fn2Parser("max")(QuantityFormula_Types.QFnMax.create)))(fn3Parser("iif")(QuantityFormula_Types.QFnIf.create));
});
var fn3Parser = function (identifier) {
    return function (astNode) {
        return lexeme(Control_Bind.bind(Text_Parsing_StringParser.bindParser)(caseInsensitive(identifier))(function () {
            return Control_Bind.bind(Text_Parsing_StringParser.bindParser)(argList(3))(function (args) {
                var mA3 = Data_List.index(args)(2);
                var mA2 = Data_List.index(args)(1);
                var mA1 = Data_List.index(args)(0);
                if (mA1 instanceof Data_Maybe.Just && (mA2 instanceof Data_Maybe.Just && mA3 instanceof Data_Maybe.Just)) {
                    return Control_Applicative.pure(Text_Parsing_StringParser.applicativeParser)(astNode(mA1.value0)(mA2.value0)(mA3.value0));
                };
                return Text_Parsing_StringParser.fail("This should not happen");
            });
        }));
    };
};
var fn2Parser = function (identifier) {
    return function (astNode) {
        return lexeme(Control_Bind.bind(Text_Parsing_StringParser.bindParser)(caseInsensitive(identifier))(function () {
            return Control_Bind.bind(Text_Parsing_StringParser.bindParser)(argList(2))(function (args) {
                var mA2 = Data_List.index(args)(1);
                var mA1 = Data_List.index(args)(0);
                if (mA1 instanceof Data_Maybe.Just && mA2 instanceof Data_Maybe.Just) {
                    return Control_Applicative.pure(Text_Parsing_StringParser.applicativeParser)(astNode(mA1.value0)(mA2.value0));
                };
                return Text_Parsing_StringParser.fail("This should not happen");
            });
        }));
    };
};
var fn1Parser = function (identifier) {
    return function (astNode) {
        return lexeme(Control_Bind.bind(Text_Parsing_StringParser.bindParser)(caseInsensitive(identifier))(function () {
            return Control_Bind.bind(Text_Parsing_StringParser.bindParser)(argList(1))(function (args) {
                var mA1 = Data_List.index(args)(0);
                if (mA1 instanceof Data_Maybe.Just) {
                    return Control_Applicative.pure(Text_Parsing_StringParser.applicativeParser)(astNode(mA1.value0));
                };
                return Text_Parsing_StringParser.fail("This should not happen");
            });
        }));
    };
};
var argList = function (n) {
    return Control_Bind.bind(Text_Parsing_StringParser.bindParser)(lexeme(Text_Parsing_StringParser_CodeUnits["char"]("(")))(function () {
        return Control_Bind.bind(Text_Parsing_StringParser.bindParser)(Text_Parsing_StringParser_Combinators.sepBy(qfParser)(lexeme(Text_Parsing_StringParser_CodeUnits["char"](","))))(function (args) {
            return Control_Bind.bind(Text_Parsing_StringParser.bindParser)(lexeme(Text_Parsing_StringParser_CodeUnits["char"](")")))(function () {
                var $28 = Data_List.length(args) !== n;
                if ($28) {
                    return Text_Parsing_StringParser.fail("Expected " + (Data_Show.show(Data_Show.showInt)(n) + (" arguments but got " + Data_Show.show(Data_Show.showInt)(Data_List.length(args)))));
                };
                return Control_Applicative.pure(Text_Parsing_StringParser.applicativeParser)(args);
            });
        });
    });
};
var parseQF = function (s) {
    var topLevelQFParser = Control_Bind.discard(Control_Bind.discardUnit)(Text_Parsing_StringParser.bindParser)(Text_Parsing_StringParser_CodeUnits.skipSpaces)(function () {
        return Control_Bind.bind(Text_Parsing_StringParser.bindParser)(qfParser)(function (ret) {
            return Control_Bind.discard(Control_Bind.discardUnit)(Text_Parsing_StringParser.bindParser)(Text_Parsing_StringParser_CodeUnits.eof)(function () {
                return Control_Applicative.pure(Text_Parsing_StringParser.applicativeParser)(ret);
            });
        });
    });
    var $29 = Data_String_Common["null"](s);
    if ($29) {
        return new Data_Either.Right(new QuantityFormula_Types.QNum(0.0));
    };
    return Text_Parsing_StringParser.runParser(topLevelQFParser)(s);
};
var parseInternalFormula = function (v) {
    return parseQF(v);
};
var parseUserFormula = function (formula) {
    return parseInternalFormula(convertToInternalFormula(formula));
};
module.exports = {
    parseQF: parseQF,
    parseInternalFormula: parseInternalFormula,
    parseUserFormula: parseUserFormula,
    convertToUserFormula: convertToUserFormula,
    convertToInternalFormula: convertToInternalFormula
};
